module.exports = __webpack_public_path__ + "static/ee52f384-a3f6-4848-8bf9-6532728b7681-2f9f379b34208621070b6c1c770ba9d0.webp";